<template>
    <div
        class="p-4 border-2 border-myflowRed rounded-wl"
    >
        <slot></slot>
    </div>
</template>
